import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

const MySkill = () => {
    return (
        <section className="bg-white py-5" style={{height:"100vh"}}>
        <Container>
        <h2
        className="text-center text-style mt-5 mb-5" 
        style={{fontFamily: `'Bebas Neue', cursive`}}>My Skills</h2>
        <Row>
        <Col xs={12} md={6} lg={4}>
        {/* <div className="comfortable pt-3 card-style"> */}
               <h4 className="text-center font-weight-lighter bg-white" 
               style={{color:"#73dfc9",  fontFamily: `"Bebas Neue", cursive`, letterSpacing:"1px"}}>Comfortable</h4>
              <ul>
                <li className="comfortable-list">React.js</li>
                <li className="comfortable-list">JavaScript</li>
                <li className="comfortable-list">MongoDB</li>
                <li className="comfortable-list">React Bootstrap</li>
                <li className="comfortable-list">REST API</li>
                <li className="comfortable-list">React Hooks</li>
                <li className="comfortable-list">React Router</li>
                <li className="comfortable-list">HTML</li>
                <li className="comfortable-list">CSS</li>
              </ul>
            
        </Col>
        <Col xs={12} md={6} lg={4}>
        
            <h4 className="text-center font-weight-lighter bg-white" 
               style={{color:"#fdd778",  fontFamily: `"Bebas Neue", cursive`, letterSpacing:"1px"}}>Familiar</h4>
              <ul>
                <li className="familiar-list">Node.js</li>
                <li className="familiar-list">Express.js</li>
                <li className="familiar-list">Material UI</li>
                <li className="familiar-list">SASS</li>
                <li className="familiar-list">JAVA</li>
                <li className="familiar-list">C/C++</li>
                <li className="familiar-list">OOP</li>
                <li className="familiar-list">JSON</li>
              </ul>       
        </Col>
        <Col xs={12} md={6} lg={4}>
            <h4 className="text-center font-weight-lighter bg-white" 
               style={{color:"#ff4c60",  fontFamily: `"Bebas Neue", cursive`, letterSpacing:"1px"}}>Tools</h4>
              <ul>
                <li className="tools-list">Firebase</li>
                <li className="tools-list">Netlify</li>
                <li className="tools-list">GitHub</li>
                <li className="tools-list">VS Code</li>
                <li className="tools-list">Heroku</li>
              </ul>
        </Col>
        </Row>
        </Container>
        </section>
    );
};

export default MySkill;